export const loansConstants = {
  LOANS_LIST_REQUEST: "LOANS_LIST_REQUEST",
  LOANS_LIST_COMPLETE: "LOANS_LIST_COMPLETE",
  LOANS_LIST_ERROR: "LOANS_LIST_ERROR",

  LOANS_ACTIVITY_LIST_REQUEST: "LOANS_ACTIVITY_LIST_REQUEST",
  LOANS_ACTIVITY_LIST_COMPLETE: "LOANS_ACTIVITY_LIST_COMPLETE",
  LOANS_ACTIVITY_LIST_ERROR: "LOANS_ACTIVITY_LIST_ERROR",

  LOAN_STATUS_PENDING: "pending",
  LOAN_STATUS_DF_PENDING: "df-pending",
};
